export const CATEGORY = 'Shrimp Suggester'